"use strict";
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedirectPopup = void 0;
const pixi_js_1 = require("pixi.js");
const i18next_1 = __importDefault(require("i18next"));
const ConfirmPopup_1 = require("./ConfirmPopup");
const blocks_1 = require("../blocks");
const Global_1 = require("../Global");
const appstore_svg_1 = __importDefault(require("../../assets/badges/appstore.svg"));
const playstore_svg_1 = __importDefault(require("../../assets/badges/playstore.svg"));
const settings_1 = require("../config/settings");
class RedirectPopup extends ConfirmPopup_1.ConfirmPopup {
    constructor(app) {
        super(app, i18next_1.default.t('support'), i18next_1.default.t('nothanks'), null, null, true);
        this.makeButtons();
        this.layout();
    }
    makeButtons() {
        this.google = this.addChild(this.makeButton(playstore_svg_1.default, 0.007));
        this.sigs.push(this.google.onPress.connect(() => {
            location.href = settings_1.Settings.googleplay;
        }));
        this.apple = this.addChild(this.makeButton(appstore_svg_1.default, 0.007));
        this.sigs.push(this.apple.onPress.connect(() => {
            location.href = settings_1.Settings.appstore;
        }));
        // TODO: Add poki button
        this.google.scale.set((0, Global_1.px)(0.18));
        this.apple.scale.set((0, Global_1.px)(0.18));
    }
    makeInfo() {
        const style = blocks_1.Block.textStyle(this.overSmallSize ? 32 : 28);
        style.wordWrap = true;
        style.wordWrapWidth = this.wrapwidth;
        style.align = 'center';
        style.lineHeight = (0, Global_1.px)(this.overSmallSize ? 46 : 36);
        const info = new pixi_js_1.Text(this.text, style);
        info.anchor.set(0.5, 0);
        return this.addChild(info);
    }
    get backgroundsettings() {
        const settings = super.backgroundsettings;
        settings.width = Math.min(settings.width, settings_1.Settings.maxWidth / 1.5);
        settings.height = Math.min(settings.height, 430);
        return settings;
    }
    layout() {
        super.layout();
        if (this.google && this.apple) {
            this.info.position.set(this.center.x, this.background.y + (0, Global_1.px)(10));
            const top = this.info.y + this.info.height + (0, Global_1.px)(50);
            if (this.isLandscapeBox) {
                const w = 100;
                const h = 10;
                this.google.position.set(this.center.x - (0, Global_1.px)(w), top + (0, Global_1.px)(h));
                this.apple.position.set(this.center.x + (0, Global_1.px)(w), top + (0, Global_1.px)(h));
            }
            else {
                this.google.position.set(this.center.x, top + (0, Global_1.px)(10));
                this.apple.position.set(this.center.x, top + (0, Global_1.px)(80));
            }
        }
    }
}
exports.RedirectPopup = RedirectPopup;
